import { useEffect } from 'react';

export const useAccessDataReset = ({ setIsValidPass, onboardingType }) => {
    useEffect(() => {
        setIsValidPass(false);
    }, [onboardingType]);
};
